import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_ATC_URL } from '@/utils';

const dashboardAtcService = createApi({
  reducerPath: 'dashboardAtcService',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_ATC_URL}/cases` }),
  tagTypes: ['Dashboard'] as const,
  endpoints: (builder) => ({
    getReportsByStatus: builder.query<any, void>({
      query: () => ({
        url: '/report-grouped-by-status-at-today',
      }),
    }),
    getPendingReport: builder.query<any, void>({
      query: () => ({
        url: '/report-count-pending',
      }),
    }),
  }),
});

export default dashboardAtcService;
export const { useGetReportsByStatusQuery, useGetPendingReportQuery } =
  dashboardAtcService;
